import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LogicService } from './logic.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    LogicService
  ]
})
export class LogicModule { }
